import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Cast, ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CastDialog } from "@/components/TvCast";

export default function TvLinkPage() {
  const { pc } = useParams();
  const nav = useNavigate();
  const { user, requireAuth } = useAuth();
  const [list, setList] = useState(null);
  const [pick, setPick] = useState(null);
  useEffect(() => {
    if (!user) { requireAuth(() => {}); return; }
    api.get("/tv/my-listings").then((r) => { setList(r.data); if (r.data.length === 1) setPick(r.data[0].id); }).catch(() => setList([]));
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="px-4 pt-4 pb-28" data-testid="tv-link-page">
      <button onClick={() => nav(-1)} className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center mb-3"><ArrowLeft className="w-4 h-4" /></button>
      <h1 className="text-2xl font-extrabold text-slate-900 flex items-center gap-2"><Cast className="w-6 h-6" />Shfaq në TV</h1>
      <p className="text-sm text-slate-500 mt-1 mb-4">Kodi i TV-së: <b data-testid="tv-link-code">{(pc || "").toUpperCase()}</b>. Zgjidh reklamën që do të shfaqet.</p>
      {!user && <p className="text-sm text-slate-600">Hyr në llogari për të vazhduar.</p>}
      {user && list === null && <div className="h-24 rounded-2xl bg-slate-100 animate-pulse" />}
      {user && list?.length === 0 && <p data-testid="tv-link-empty" className="text-sm text-slate-600 bg-amber-50 rounded-2xl p-4">Nuk ke asnjë reklamë me rrotë produktesh. Shto produkte te Dyqan ose Shërbime.</p>}
      <div className="space-y-2">
        {(list || []).map((l) => (
          <button key={l.id} data-testid={`tv-link-pick-${l.id}`} onClick={() => setPick(l.id)} className="w-full text-left bg-white border border-slate-100 rounded-2xl p-3 flex items-center gap-3">
            <Cast className="w-5 h-5 text-emerald-600" />
            <span className="flex-1 min-w-0"><span className="block font-bold text-sm truncate">{l.title}</span><span className="block text-xs text-slate-400 truncate">{l.wheels.join(" · ")}</span></span>
          </button>
        ))}
      </div>
      {pick && <CastDialog listingId={pick} tvCode={pc} onClose={() => setPick(null)} />}
    </div>
  );
}
